export const ALERT_TITLE = {
  FORECAST_OPENS_SOON: 'FORECAST OPENS SOON:',
  FORECAST_OPENS_TOMORROW: 'FORECAST OPENS TOMORROW:',
  FORECAST_OPENS_TODAY: 'FORECAST OPENS TODAY:',

  FORECAST_DUE: 'FORECAST DUE:',
  FORECAST_DUE_SOON: 'FORECAST DUE SOON:',
  FORECAST_DUE_TOMORROW: 'FORECAST DUE TOMORROW:',
  FORECAST_DUE_TODAY: 'FORECAST DUE TODAY:',

  FORECAST_SUBMITTED: 'FORECAST SUBMITTED:',
  FORECAST_COMPLETED: 'FORECAST COMPLETED:',
  FORECAST_CLOSED: 'FORECAST CLOSED:',
  FORECAST_MISSED: 'FORECAST MISSED:',
};

export const ALERT_TYPE = {
  NEEDS_ACTION: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  INFO: 'info',
};
